import { createContext, useContext } from 'react';
import type { ReactElement, ReactNode } from 'react';
import PropTypes from 'prop-types';
import useOfferData from '../../components/experiments/useOfferData';

/**
 * Value exposed by {@link AdobeExperimentContext}. Mirrors the state returned by
 * `useAsyncData`; every field is optional so the empty default value is valid.
 */
export type AdobeExperimentState = {
    data?: unknown;
    error?: unknown;
    fetching?: boolean;
    initialising?: boolean;
};

export const AdobeExperimentContext = createContext<AdobeExperimentState>({});

const AdobeExperimentProvider = ({ children }: { children: ReactNode }): ReactElement => {
    const state = useOfferData();
    return <AdobeExperimentContext.Provider value={state}>{children}</AdobeExperimentContext.Provider>;
};

export const useAdobeExperiments = (): AdobeExperimentState => useContext(AdobeExperimentContext);

export default AdobeExperimentProvider;

AdobeExperimentProvider.propTypes = {
    children: PropTypes.node.isRequired
};
